import { FC } from 'react';
import { Divider, Flex, FormLabel, Grid, Stack } from '@chakra-ui/react';
import { Feature } from '@shinetools/pricing-plan-library';

import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';
import LogoUpload from 'components/LogoUpload';
import UpgradablePlanBadge from 'components/UpgradablePlanBadge';

import Section from '../../../Section';
import locales from './locales';

interface CustomizationSectionProps {
  logoUrl?: string | null;
}

const CustomizationSection: FC<CustomizationSectionProps> = ({ logoUrl }) => {
  const { isFeatureAvailable } = useCurrentPricingPlan();

  const isPersonalizedLogoAvailable = isFeatureAvailable(
    Feature.PersonalizedLogo,
  );

  return (
    <Section title={locales.title}>
      <Stack divider={<Divider />} spacing="space-16">
        <Grid rowGap="space-4">
          <Flex alignItems="center" columnGap="space-8">
            <FormLabel>{locales.logo}</FormLabel>

            {!isPersonalizedLogoAvailable ? (
              <UpgradablePlanBadge
                feature={Feature.PersonalizedLogo}
                size="sm"
              />
            ) : null}
          </Flex>

          <LogoUpload logoUrl={logoUrl ?? null} />
        </Grid>
      </Stack>
    </Section>
  );
};

export default CustomizationSection;
